import { render, staticRenderFns } from "./StepIndicatorSimple.vue?vue&type=template&id=3cf718fa&"
import script from "./StepIndicatorSimple.vue?vue&type=script&lang=js&"
export * from "./StepIndicatorSimple.vue?vue&type=script&lang=js&"
import style0 from "./StepIndicatorSimple.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports